import {FormikErrors} from 'formik';
import {builderFieldsType} from '../CreateBuilder/builderFields';

export const protectionPlanValidator = (
  values: builderFieldsType,
  errors: FormikErrors<builderFieldsType>
): FormikErrors<builderFieldsType> => {
  if (!values.goal?.id) {
    if (!values.isSppDa) {
      errors.goal = 'Please select a goal';
    }
  }
  const protectionPlanValues = values.protectionPlan;
  if (!protectionPlanValues) {
    errors.protectionPlan = 'Fill in fields';
    return errors;
  }

  return errors;
};
